export const getToken = () => new URLSearchParams(location.search).get('session_token');
export const getSchema = () => new URLSearchParams(location.search).get('schema');
